import React from "react"
import { hydrate } from "react-dom"
import { QueryClient, Hydrate } from "react-query"

import { library } from "@fortawesome/fontawesome-svg-core"
import "@fortawesome/fontawesome-svg-core/styles.css"
import { faIcons as legosFaIcons } from "@ncs/web-legos"
import { faIcons as localFaIcons } from "~/util"

import { setBaseUrl, setEcommBaseUrl } from "@ncs/ncs-api"
import { integrateAnalyticsPlatforms, setUspsUserName, visualSearch } from "@ncs/web-legos"

import App from "~/App"
import { AppProvider } from "~/contexts"
import AnalyticsClient from "~/util/analytics-client"

// Initialize FontAwesome icon library
library.add(...(localFaIcons as any), ...(legosFaIcons as any))

// Pass in some config info that our libraries need.
setBaseUrl(import.meta.env.VITE_PORTAL_SERVICE_URL)
setEcommBaseUrl(import.meta.env.VITE_ECOMM_SERVICE_URL)
setUspsUserName(import.meta.env.VITE_USPS_USER_NAME)

// Create a new QueryClient for the client
const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false,
			staleTime: 1000 * 60, // 1 min stale time
		},
	},
})

const app = (
	<AppProvider queryClient={queryClient}>
		<Hydrate state={(window as any).__REACT_QUERY_STATE__}>
			<App />
		</Hydrate>
	</AppProvider>
)

const container = document.getElementById("root")
if (container) {
	hydrate(app, container)

	// Remove server-side Material UI styles after hydration
	const jssStyles = document.querySelector("#jss-server-side")
	if (jssStyles && jssStyles.parentElement) {
		jssStyles.parentElement.removeChild(jssStyles)
	}

	visualSearch()
	AnalyticsClient.getInstance().init(
		import.meta.env.VITE_AMPLITUDE_KEY,
		import.meta.env.VITE_AMPLITUDE_EXPERIMENT_KEY
	)
	integrateAnalyticsPlatforms()
}
